import {
  IinitialMyBrandsState,
  IMyBrand,
  IMyBrandsBrandPointOfSale,
} from 'interfaces/myBrands.interface';
import * as MyBrandsTypes from './myBrands.types';
import { connected } from 'interfaces/general.interface';

export type TmyBrandsDispatchReducer =
  | {
      type: typeof MyBrandsTypes.GET_MY_BRANDS;
      payload: Array<IMyBrand>;
    }
  | {
      type: typeof MyBrandsTypes.ADD_TO_MY_BRAND;
      payload: Array<IMyBrand>;
    }
  | {
      type: typeof MyBrandsTypes.REMOVE_FROM_MY_BRAND;
      payload: string;
    }
  | {
      type: typeof MyBrandsTypes.REMOVE_FROM_MY_BRAND_MULTIPLE;
      payload: Array<IMyBrand>;
    }
  | {
      type: typeof MyBrandsTypes.SET_IS_LOADING_GET_MY_BRANDS;
      payload: boolean;
    }
  | {
      type: typeof MyBrandsTypes.CREATE_NEW_BRAND;
      payload: IMyBrand;
    }
  | {
      type: typeof MyBrandsTypes.SET_POINTS_OF_SALE_CONNECTED;
      payload: Array<IMyBrandsBrandPointOfSale>;
    }
  | {
      type: typeof MyBrandsTypes.SET_ADD_TO_MY_BRAND_MULTIPLE_STATUS;
      payload: {
        haveBrandsToAdd?: boolean;
        isLoading?: boolean;
        totalBrands?: number;
        brandsToAdd?: number;
        brandsAdded?: number;
        isOpenModal?: boolean;
      };
    }
  | {
      type: typeof MyBrandsTypes.SET_IS_LOADING_ADD_TO_MY_BRAND;
      payload: {
        isLoading: boolean;
        tenantId: string;
      };
    }
  | {
      type: typeof MyBrandsTypes.EMAIL_RESEND;
      payload: {
        id: string;
        emailResend: boolean;
      };
    }
  | {
      type: typeof MyBrandsTypes.SET_IS_LOADING_RESEND_EMAIL_VERIFICATION;
      payload: {
        isLoading: boolean;
        tenantId: string | null;
      };
    };

export default function myBrandsReducer(
  state: IinitialMyBrandsState,
  action: TmyBrandsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case MyBrandsTypes.GET_MY_BRANDS: {
      const getMyBrands: IinitialMyBrandsState = {
        ...state,
        myBrands: payload,
        connectedBrands: payload.filter((brand: any) => brand.state_name === connected),
      };
      return getMyBrands;
    }

    case MyBrandsTypes.SET_IS_LOADING_GET_MY_BRANDS: {
      const setIsLoading: IinitialMyBrandsState = {
        ...state,
        isLoadingGetMyBrands: payload,
      };
      return setIsLoading;
    }

    case MyBrandsTypes.ADD_TO_MY_BRAND: {
      const addToMyBrand: IinitialMyBrandsState = {
        ...state,
        myBrands: payload,
      };
      return addToMyBrand;
    }

    case MyBrandsTypes.SET_IS_LOADING_ADD_TO_MY_BRAND: {
      const setIsLoadingAddToMyBrand: IinitialMyBrandsState = {
        ...state,
        isLoadingAddToMyBrand: {
          isLoading: payload.isLoading,
          tenantId: payload.tenantId,
        },
      };
      return setIsLoadingAddToMyBrand;
    }

    case MyBrandsTypes.REMOVE_FROM_MY_BRAND: {
      const removeFromMyBrand: IinitialMyBrandsState = {
        ...state,
        myBrands: state.myBrands.filter((brand) => brand.key !== payload),
      };
      return removeFromMyBrand;
    }

    case MyBrandsTypes.REMOVE_FROM_MY_BRAND_MULTIPLE: {
      const removeFromMyBrand: IinitialMyBrandsState = {
        ...state,
        myBrands: payload,
      };
      return removeFromMyBrand;
    }

    case MyBrandsTypes.CREATE_NEW_BRAND: {
      const createNewBrand: IinitialMyBrandsState = {
        ...state,
        myBrands: [payload, ...state.myBrands],
      };
      return createNewBrand;
    }

    case MyBrandsTypes.SET_POINTS_OF_SALE_CONNECTED: {
      const setPointsOfSaleConnected: IinitialMyBrandsState = {
        ...state,
        pointsOfSaleConnected: payload,
      };
      return setPointsOfSaleConnected;
    }

    case MyBrandsTypes.SET_ADD_TO_MY_BRAND_MULTIPLE_STATUS: {
      const setAddToMyBrandMultipleStatus: IinitialMyBrandsState = {
        ...state,
        addToMyBrandMultipleStatus: {
          ...state.addToMyBrandMultipleStatus,
          ...payload,
        },
      };
      return setAddToMyBrandMultipleStatus;
    }

    case MyBrandsTypes.EMAIL_RESEND: {
      const emailResend: IinitialMyBrandsState = {
        ...state,
        myBrands: state.myBrands.map((brand) => {
          if (brand.tenant_id === payload.id) {
            return { ...brand, emailResend: payload.emailResend };
          }
          return brand;
        }),
      };
      return emailResend;
    }

    case MyBrandsTypes.SET_IS_LOADING_RESEND_EMAIL_VERIFICATION: {
      const setIsLoadingResendEmailVerification: IinitialMyBrandsState = {
        ...state,
        isLoadingResendAssociationEmail: {
          isLoading: payload.isLoading,
          tenantId: payload.tenantId,
        },
      };
      return setIsLoadingResendEmailVerification;
    }

    default:
      return state;
  }
}
